export const animatePhotoPageTranslations = {
    ru: {
        title: "Оживление фото",
        description: "Оживите ваши фотографии с помощью AI",
        photo: "Фото",
        uploadPhoto: "Загрузить фото",
        changePhoto: "Изменить фото",
        removePhoto: "Удалить фото",
        prompt: "Промпт",
        promptPlaceholder: "Введите описание того, как оживить фотографию...",
        promptDescription: "Опишите, как вы хотите оживить фотографию",
        animate: "Оживить",
        processing: "Обработка...",
        selectPhoto: "Выберите фотографию для оживления",
        tabAnimate: "Оживить",
        tabMyPhotos: "Мои оживленные фото",
        noPhotos: "У вас пока нет оживленных фотографий",
        loadingPhotos: "Загрузка фотографий...",
        createdAt: "Создано",
        download: "Скачать",
        delete: "Удалить",
    },
    en: {
        title: "Animate Photo",
        description: "Bring your photos to life with AI",
        photo: "Photo",
        uploadPhoto: "Upload photo",
        changePhoto: "Change photo",
        removePhoto: "Remove photo",
        prompt: "Prompt",
        promptPlaceholder: "Enter a description of how to animate the photo...",
        promptDescription: "Describe how you want to animate the photo",
        animate: "Animate",
        processing: "Processing...",
        selectPhoto: "Select a photo to animate",
        tabAnimate: "Animate",
        tabMyPhotos: "My Animated Photos",
        noPhotos: "You don't have any animated photos yet",
        loadingPhotos: "Loading photos...",
        createdAt: "Created",
        download: "Download",
        delete: "Delete",
    },
};
